
<template>
  <div>
    <div style="margin:0 auto;width:0px;height:0px;overflow:hidden;">
      <img src="./image/0.jpeg" width="700" />
    </div>
    <section id="activity-detail" class="pc_device">
      <div class="page-bizinfo">
        <div class="header">
          <h1 id="activity-name">如何确认WiFi已被分享</h1>
        </div>
      </div>

      <div id="page-content" class="page-content">
        <div class="text">
          <p>
            <span style="font-size: 14px;">
              <strong>一、请确认WiFi已分享，即WiFi带有蓝色小钥匙。</strong>
            </span>
            <img src="./image/0.jpeg" />
          </p>
          <p>
            <strong>
              <span style="font-size: 14px;">如果WiFi尚未被分享，可以点击这个WiFi，在底部弹窗点击“分享热点”。</span>
            </strong>
          </p>
          <p>
            <strong>
              <span style="font-size: 14px;">分享热点提交信息后，请完全退出WiFi万能钥匙，然后过几分钟重新打开，查看是否是在分享的状态。</span>
            </strong>
          </p>
          <p>
            <img src="./image/1.jpeg" />
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'newisShare'
}
</script>

<style  scoped>
#activity-detail {
  max-width: 640px;
  /*min-height: 100%;*/
  margin: 0 auto;
  padding: 0 40px;
  background-color: #fff;
}
.page-bizinfo {
  padding: 25px 0;
}

#activity-detail .video-frame {
  width: 100% !important;
  overflow: hidden;
}

.page-toolbar {
  padding-bottom: 20px;
  overflow: hidden;
  padding-top: 20px;
  *zoom: 1;
}

.page-toolbar a {
  color: #0067ed;
  text-decoration: none;
  text-shadow: 0 1px #fff;
  -webkit-text-shadow: 0 1px #ffffff;
  -moz-text-shadow: 0 1px #ffffff;
}

.text {
  padding-bottom: 30px;
}

.text p {
  margin: 10px 0;
  line-height: 10px;
  padding: 0px;
  color: #000;
}

.text p span {
  line-height: 30px;
}

.text img {
  max-width: 100% !important;
  height: auto !important;
}

.text li {
  word-wrap: break-word;
}

#activity-name {
  font-size: 20px;
  color: #333;
  line-height: 20px;
  text-align: center;
  margin-bottom: 5px;
}
#activity-detail {
  padding: 0 15px;
}

.page-bizinfo {
  padding-top: 20px;
  padding-bottom: 15px;
}

.pc_device .page-bizinfo {
  padding-top: 30px;
}

.text {
  font-size: 16px;
  color: #1e2330;
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// isShare.vue?e77e0c0c